// Persisted-cache format version.
//
// Two stores hold the client's cache, and they describe each other:
//
//   * IndexedDB  — the individuals themselves (rec-cache-idb.js)
//   * localStorage — the etagMap, i.e. which twins were current as of the
//     last sync and what their relationship signature hashed to
//     (adt-client.js)
//
// They must be invalidated together. Dropping the etagMap while IndexedDB
// stays populated is the worst possible state: every twin arrives as an
// update, none are skipped, and the sync pays the expensive path for the
// whole graph. Measured on a 23,742-twin instance that state took ~24
// minutes, against ~9 minutes starting from nothing and ~3 minutes with
// both caches intact.
//
// Deriving both keys from this one constant makes that state unreachable
// by version drift: bump it and both caches clear together.
//
// BUMP THIS ONLY when the persisted shape changes — the IndexedDB record
// layout, or the relHash construction in adt-client.js. It is deliberately
// NOT tied to the app version. It used to be, and the effect was that every
// deployment silently orphaned the etagMap and cost each user a full
// re-parse of the graph on their next load.
//
// Forgetting to bump it after a format change is the failure this guards
// against, and it fails silently: stale twins get skipped with no error.
// If you change how an individual is persisted, or how relHash is built,
// bump it.
//
// v6 — decoupled from the app version (was CACHE_VERSION 5 + etagMap_v{app})
export const CACHE_FORMAT_VERSION = 6
